﻿import { Text, Title3 } from "@fluentui/react-components";
import { CheckIcon } from "../icons/CheckIcon";
import DOMPurify from "dompurify";
import { PoweredByFooter } from "../PoweredByFooter/PoweredByFooter";
import { useStyles } from "./externalDiagnosticsClosing.styles";
import { IExternalDiagnosticsClosingProps } from "./externalDiagnosticsClosing.types";
import { useMemo } from "react";

export const ExternalDiagnosticsClosing = (
  props: IExternalDiagnosticsClosingProps,
): JSX.Element => {
  const styles = useStyles();

  const sanitized = useMemo(
    () =>
      props.closingMessage ? DOMPurify.sanitize(props.closingMessage) : "",
    [props.closingMessage],
  );

  const hasContent = useMemo(() => {
    const doc = new DOMParser().parseFromString(sanitized, "text/html");
    return (
      (doc.body.textContent ?? "").replace(/\u00A0/g, "").trim().length > 0
    );
  }, [sanitized]);

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.checkmarkCircle}>
          <CheckIcon />
        </div>

        <Title3 className={styles.title}>{props.diagnosticName}</Title3>

        {hasContent ? (
          <div
            className={styles.messagecontent}
            dangerouslySetInnerHTML={{ __html: sanitized }}
          />
        ) : (
          <Text className={styles.messagecontent}>
            Thank you for completing this interview!
          </Text>
        )}
        {/* to be used in the future when export functionality is implemented */}
        {/* <Button
          className={styles.exportButton}
          appearance="outline"
          icon={<ArrowDownload24Regular />}
          onClick={props.onExportResponses}
        >
          Export my responses
        </Button>

        <div className={styles.exportCaption}>
          Downloads a PDF copy of your answers
        </div> */}
      </div>

      <div>
        <PoweredByFooter />
      </div>
    </div>
  );
};
